(function () {
  const root = document.querySelector('[data-blog-section]');
  if (!root) return;

  const nav = root.querySelector('.blog-nav');
  const input = root.querySelector('[data-blog-search]');
  const cards = Array.from(root.querySelectorAll('[data-blog-card]'));
  const empty = root.querySelector('[data-blog-empty-search]');

  if (nav) {
    const scrollKey = 'blog-nav-scroll';
    const savedScroll = Number(sessionStorage.getItem(scrollKey) || 0);
    const activeLink = nav.querySelector('.blog-nav__link.is-active');

    if (savedScroll > 0) {
      nav.scrollLeft = savedScroll;
    }

    if (activeLink) {
      const navRect = nav.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();
      const isOverflowing =
        linkRect.left < navRect.left + 8 || linkRect.right > navRect.right - 8;

      if (isOverflowing) {
        activeLink.scrollIntoView({
          inline: 'center',
          block: 'nearest',
          behavior: 'auto',
        });
      }
    }

    nav.querySelectorAll('a').forEach((link) => {
      link.setAttribute('draggable', 'false');
    });

    nav.addEventListener('scroll', () => {
      sessionStorage.setItem(scrollKey, String(nav.scrollLeft));
    }, { passive: true });

    let pointerId = null;
    let isPointerDown = false;
    let isDragging = false;
    let startX = 0;
    let startScroll = 0;

    nav.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') return;

      pointerId = event.pointerId;
      isPointerDown = true;
      isDragging = false;
      startX = event.clientX;
      startScroll = nav.scrollLeft;
    });

    nav.addEventListener('pointermove', (event) => {
      if (!isPointerDown || event.pointerId !== pointerId) return;

      const delta = event.clientX - startX;
      if (!isDragging && Math.abs(delta) > 8) {
        isDragging = true;
        nav.classList.add('is-dragging');
        nav.setPointerCapture(event.pointerId);
      }

      if (isDragging) {
        event.preventDefault();
        nav.scrollLeft = startScroll - delta;
      }
    });

    const stopDrag = (event) => {
      if (!isPointerDown || event.pointerId !== pointerId) return;

      isPointerDown = false;
      pointerId = null;
      nav.classList.remove('is-dragging');

      if (nav.hasPointerCapture(event.pointerId)) {
        nav.releasePointerCapture(event.pointerId);
      }

      window.setTimeout(() => {
        isDragging = false;
      }, 0);
    };

    nav.addEventListener('pointerup', stopDrag);
    nav.addEventListener('pointercancel', stopDrag);
    nav.addEventListener('lostpointercapture', () => {
      isPointerDown = false;
      nav.classList.remove('is-dragging');
    });

    nav.addEventListener('click', (event) => {
      if (!isDragging) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    nav.addEventListener(
      'wheel',
      (event) => {
        if (nav.scrollWidth <= nav.clientWidth) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        nav.scrollLeft += event.deltaY;
        event.preventDefault();
      },
      { passive: false }
    );
  }

  if (!input || !cards.length) return;

  const clearButton = root.querySelector('[data-blog-search-clear]');
  const paginations = root.querySelectorAll('.blog-pagination');

  const filterCards = () => {
    const query = input.value.trim().toLowerCase();
    let visible = 0;

    cards.forEach((card) => {
      const haystack = (card.getAttribute('data-search') || '').toLowerCase();
      const match = !query || haystack.includes(query);
      card.hidden = !match;
      if (match) visible += 1;
    });

    if (empty) empty.hidden = visible > 0;
    if (paginations.length) {
      paginations.forEach((pagination) => {
        pagination.hidden = Boolean(query);
      });
    }
    if (clearButton) clearButton.hidden = !input.value;
  };

  filterCards();

  input.addEventListener('input', filterCards);
  input.addEventListener('search', filterCards);

  clearButton?.addEventListener('click', () => {
    input.value = '';
    input.focus();
    filterCards();
  });
})();
